module.exports = __webpack_public_path__ + "img/facebook.798043af.svg";